import React, { createContext, useContext, useEffect, useState } from 'react';
import { getRemoteConfig, getValue, fetchAndActivate } from 'firebase/remote-config';
import { app } from '../backend/firebaseFunctions';

const RemoteConfigContext = createContext();

export const useRemoteConfig = () => {
    const context = useContext(RemoteConfigContext);
    if (!context) {
        throw new Error('useRemoteConfig must be used within a RemoteConfigProvider');
    }
    return context;
};

export const RemoteConfigProvider = ({ children }) => {
    const [isLoading, setIsLoading] = useState(true);
    const [paymentsWebActive, setPaymentsWebActive] = useState(true); // Default to true for safety
    const [error, setError] = useState(null);

    useEffect(() => {
        const initializeRemoteConfig = async () => {
            try {
                // Initialize Remote Config
                const remoteConfig = getRemoteConfig(app);

                // Set minimum fetch interval to 0 for development (default is 12 hours)
                if (process.env.NODE_ENV === 'development') {
                    remoteConfig.settings.minimumFetchIntervalMillis = 0;
                }

                // Set default values
                remoteConfig.defaultConfig = {
                    paymentsWebActive: true
                };

                // Fetch and activate config
                await fetchAndActivate(remoteConfig);

                // Get the paymentsWebActive value
                const paymentsConfig = getValue(remoteConfig, 'paymentsWebActive');
                const paymentsActive = paymentsConfig.asBoolean();


                setPaymentsWebActive(paymentsActive);
                setIsLoading(false);
            } catch (err) {
                console.error('Error loading Remote Config:', err);
                setError(err);
                // Keep default value (true) for safety
                setIsLoading(false);
            }
        };

        initializeRemoteConfig();
    }, []);

    const value = {
        isLoading,
        paymentsWebActive,
        error
    };

    return (
        <RemoteConfigContext.Provider value={value}>
            {children}
        </RemoteConfigContext.Provider>
    );
};
